// Mirrors CHECKOUT_URLS from @unity/commerce-ui
// (packages/ui/src/core/constants.ts) which is not exported from @unity/commerce-core
const CHECKOUT_URLS = {
  DEVELOPMENT: 'https://checkout.local.unity.com',
  TEST: 'https://checkout-test.unity.com',
  STAGING: 'https://checkout-staging.unity.com',
  PRODUCTION: 'https://checkout.unity.com',
} as const;

export type BuildCheckoutUrlArgs = {
  env: string | undefined;
  cartId: string;
  returnToCartUrl?: string;
};

export const buildCheckoutUrl = ({
  env,
  cartId,
  returnToCartUrl,
}: BuildCheckoutUrlArgs): string => {
  const envKey = (env ?? 'staging')
    .trim()
    .toUpperCase() as keyof typeof CHECKOUT_URLS;
  const baseUrl = CHECKOUT_URLS[envKey] ?? CHECKOUT_URLS.STAGING;
  const checkoutUrl = new URL(`${baseUrl}/cart/${cartId}/pay`);
  if (returnToCartUrl) {
    checkoutUrl.searchParams.append('returnToCartUrl', returnToCartUrl);
  }
  return checkoutUrl.toString();
};
